// extracted by extract-css-chunks-webpack-plugin
module.exports = {"note":"view-message__note--3Q3Ks"};